import { defineSlotRecipe } from '@chakra-ui/react';

export const mapAdvancedMarkerSlotRecipe = defineSlotRecipe({
    slots: ['container', 'circle'],
    base: {
        container: {
            fontWeight: 'bold',
        },
    },
    variants: {
        variant: {
            accommodation: {
                container: {
                    position: 'relative',
                    backgroundColor: 'var(--marker-bg-color, white)',
                    color: 'black',
                    padding: 2,
                    borderRadius: 'lg',
                    fontSize: 'sm',
                    minWidth: '50px',
                    minH: '30px',
                    boxShadow: '2xl',

                    _after: {
                        content: '""',
                        position: 'absolute',
                        bottom: '-7px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: 0,
                        height: 0,
                        borderLeft: '8px solid transparent',
                        borderRight: '8px solid transparent',
                        borderTop: '8px solid var(--marker-bg-color, white)',
                    },
                },
            },
            cluster: {
                container: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bg: 'secondary.600',
                    color: 'white',
                    fontSize: 'md',
                    paddingInline: 3,
                    paddingBlock: 2,
                    minW: '2.5rem',
                    aspectRatio: '1 / 1',
                    borderRadius: 'full',
                    boxShadow: '0 0 0 8px rgba(0, 80, 160, 0.2)',
                },
            },
        },
        selected: {
            true: {
                container: {
                    '--marker-bg-color': 'var(--chakra-colors-secondary-600)',

                    color: 'white',
                },
            },
            false: {},
        },
        unavailable: {
            true: {
                container: {
                    '--marker-bg-color': '{colors.brand.solid}',

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: '30px',
                    padding: '6px',
                    borderRadius: 'full',

                    _after: {
                        bottom: '-6px',
                        borderWidth: '9px 9px 0 9px',
                    },
                },
                circle: {
                    display: 'block',
                    width: '.9em',
                    height: '.9em',
                    borderRadius: 'full',
                    bg: 'white',
                },
            },
            false: {},
        },
    },
});
